<template>
  <div style="width:100%">
    <div class="roomBox" v-loading='loading' v-if="dataList.length>0">
      <div v-for="(item,index) in dataList" :key="index" class="li flex_col"  @click="go(item)"
        :style="{
          width:'268px !important',
          marginRight:'27px'
        }">
        <div class="title">
          <img :src="item.logo" alt="" width="100%">
        </div>
        <div class="bottomBox">
            <span>{{item.name}}</span>
        </div>
      </div>
    </div>
    <page @navpage='changePage' :current='pageparm.currentPage' :total='pageparm.total' :pageSize='pageparm.pageSize'></page>
    
    <!-- <pagination v-bind:child-msg="pageparm" @callFather="changePage" v-if="dataList.length>0"></pagination> -->

    <!-- <div style="margin-top: 6rem;" v-else> -->
      <!-- <img src="@/assets/image/noData.png" alt="">
      <span class="noData">暂无数据</span>
      <mbtn red  round name='前往创建洽谈室' @click="$router.push({name:'room'})"></mbtn> -->
      <!-- <noData></noData> -->
    <!-- </div> -->

  </div> 
</template>
<script>
// 导入组件
// import { menu } from '@/api/userMG'
// import noData from '@/components/noData'

// import pagination from '@/components/pagination'
import page from '@/view/CloudFair/components/page.vue'


export default {
  name: 'roomList',
  // 注册组件
  components: {
    page,
  },
  model:{
    prop:'value',
    event:"change"
  },
  props:{
    myRoom:Boolean,
    value:{
      type:Array,
      default(){
        return []
      }
    },
    hoverBg:{
      type:String,
      default:'bg1'
    },
    getDataFun:Function,
    pageSize:{
      type:Number,
      default:6
    },
    rowNumber:{
      type:Number,
      default:3
    },
    liWidth:{
      type:String,
      default:'32%'
    },
    margin:{
      type:String,
      default:'1.5%'
    },
    searchForm:{
      type:Object,
    }
  },
  data() {
    return {      
      loading:false,
      form:{
        // userId:'zongheng',
        pageNum:1,
        pageSize:this.pageSize
      },
      dataList:this.value,
      pageparm: {
        currentPage: 1,
        pageSize: this.pageSize,
        total: 0
      },
  
    }
  },
  computed:{
    
  },
  methods: {
    go(item){
      window.open(item.url)
    },
    copy(){ 
      var input = document.createElement('input')
      input .value=this.shareForm.text
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      document.body.removeChild(input)
      this.copyOk=true
      
    },
    changePage(parm) {
      console.log(parm)
      
      this.form.pageNum = parm
      // this.form.pageSize = parm.pageSize
      this.getData()
    },

    getData(form=this.form,pageNo){
      if(this.searchForm)
      {
        form = Object.assign(this.searchForm,form)
      }
      if(pageNo)
      {
        form.pageNo=1
      }
      if(this.getDataFun)
      {
        this.loading=true
        this.getDataFun(form).then(({code,data,msg})=>{
          this.loading=false
          if(code==100){
            this.dataList=data.rows
            this.$emit('change',data.rows)
            const { current,size,total} = data
            this.pageparm.currentPage = data.pageNumber
            this.pageparm.pageSize = size
            this.pageparm.total = data.sumLine
          } 
        }).catch(res=>{
          this.loading=false
          console.log(res)});
      }
    }
  },
  created() {
    this.getData()

  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    
  }
}
</script>
<style scoped lang="less">

.roomBox
{
  // width: var(--rowNumber);
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  justify-content:  flex-start;
 
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  
  &>.li
  {
    overflow: hidden;
    background: transparent;
    border: 0.1rem solid #EFEFEF;
    border-radius: 0.6rem;
    width: 32%;
    margin-bottom: 2.1rem;
    // height: 30rem;
    text-align: left;
    box-shadow: 0px 0.3rem 0.7rem 0.1rem rgba(0, 0, 0, 0.12);
    // @extend .cursor;
    & button:hover
    {
      background-color: #FDE6E8;
      border-radius: 0.4rem;
    
      font-size: 1.2rem;
      font-weight: 400;
      // color: $colorRed;
      transition: 0.5S;

    }
    &:hover{
      transform: translate(0rem,-1rem);
      transition: 0.5S;
      & .bottomBox
      {
        color: #DC0006FF;
      }
      // box-shadow: 0px 1rem 1rem 0rem rgba(255, 0, 0, 1);
      box-shadow: 0 0px 0px 0 #EA0E1E, 4px 4px 0 0 #EA0E1E;
    }

    .title
    {
      
      width: 100%;
      background: #F7F7F9;
      border-radius: 0.6rem 0.6rem 0px 0px;
      height: 12rem;
      
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      
      font-size: 1.6rem;
      font-weight: 400;
      color: #333333;
      position: relative;
      .textOver
      {
        -webkit-box-orient: vertical;

        -webkit-line-clamp: 3;
      }
      .tip
      {
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 0.6rem 0px 0.6rem 0px;
        // background: $colorRed;
        font-size: 1.4rem;
        font-weight: 400;
        color: #FEFEFE;
        padding: 0.7rem 1.4rem;
      }
    }
  }
  .bottomBox
  {
    
    flex: 1;
   
    display: flex;
    
    flex-direction: column;
    -ms-flex-align: start;
    align-items: center;
    justify-content: space-between;
    padding: 2rem 0;
    width: 90%;
    margin: auto;
    height: 82px;
    
    // width: 48px;
    // height: 17px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }
}
#shareOk
{
 
  font-size: 1.4rem;
  font-weight: 400;
  // color: $colorRed;
  margin-top: -2rem !important;
}
</style>



// WEBPACK FOOTER //
// src/view/exhibitionHall/roomList.vue